var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6V26C2 27.0609 2.42143 28.0783 3.17157 28.8284C3.92172 29.5786 4.93913 30 6 30H26C27.0609 30 28.0783 29.5786 28.8284 28.8284C29.5786 28.0783 30 27.0609 30 26V6C30 4.93913 29.5786 3.92172 28.8284 3.17157C28.0783 2.42143 27.0609 2 26 2H6ZM8.204 10.594C8.83787 10.594 9.44577 10.3422 9.89398 9.89398C10.3422 9.44577 10.594 8.83787 10.594 8.204C10.594 7.57013 10.3422 6.96223 9.89398 6.51401C9.44577 6.0658 8.83787 5.814 8.204 5.814C7.57013 5.814 6.96223 6.0658 6.51401 6.51401C6.0658 6.96223 5.814 7.57013 5.814 8.204C5.814 8.83787 6.0658 9.44577 6.51401 9.89398C6.96223 10.3422 7.57013 10.594 8.204 10.594ZM10.204 25.626V12.468H6.204V25.626H10.204ZM12.86 12.468H16.86V14.23C17.45 13.306 18.746 12.062 21.156 12.062C24.032 12.062 25.594 13.968 25.594 17.594C25.594 17.768 25.61 18.562 25.61 18.562V25.624H21.61V18.564C21.61 17.594 21.406 15.688 19.25 15.688C17.092 15.688 16.91 18.084 16.86 19.652V25.624H12.86V12.468Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1ed4f0ccd86f64a599acb8a3aae69a10.svg";
export { ForwardRef as ReactComponent };